<script>
import { mapActions, mapState } from "pinia";
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import {
  ENGAGEMENT_ICONS,
  EngagementActionMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import ActiveActionIcon from "%/dynamic-component-editor/options/active-action-icon";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import { useSavedPostsStore } from "%/dynamic-component-editor/stores/saved-posts-store";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";
import { mountSaveChooser } from "%/dynamic-component-editor/components/saved-posts/mount-save-chooser";

export default {
  name: "SaveAction",
  actionLabel: "Save",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.ACTIONS,
    displayIcon: "bookmark",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [BaseStoryCardElementMixin, EngagementActionMixin],
  options: [
    new ActiveActionIcon({ "default": ENGAGEMENT_ICONS.saved }),
  ],
  optionBundles: [
    new ButtonActionOptions({ "default.icon": ENGAGEMENT_ICONS.save }),
  ],
  data() {
    return { chooserOwner: false, unmountChooser: null };
  },
  computed: {
    ...mapState(useConfigurationStore, ["canSavePosts"]),
    ...mapState(useSavedPostsStore, ["isSaved", "pendingByStory", "chooser"]),
    isEngagementActive() {
      return this.isSaved(this.storyEntityId);
    },
    myValue() {
      return "";
    },
    shouldShowAction() {
      return this.editMode || this.canSavePosts;
    },
    isChoosingCollection() {
      return !this.editMode && this.chooser.storyId > 0 && this.chooser.storyId === Number(this.storyEntityId) && this.chooserOwner;
    },
  },
  watch: {
    storyEntityId: {
      immediate: true,
      handler(storyId) {
        if (!this.editMode && !this.isPreviewMode && this.canSavePosts) {
          this.watchSavedStatus(storyId);
        }
      },
    },
    "chooser.storyId"(storyId) {
      if (!storyId) {
        this.chooserOwner = false;
      }
    },
    isChoosingCollection(choosing) {
      if (choosing && !this.unmountChooser) {
        this.unmountChooser = mountSaveChooser(this.$.appContext);
      }
      if (!choosing) {
        this.closeMountedChooser();
      }
    },
  },
  beforeUnmount() {
    this.closeMountedChooser();
  },
  methods: {
    ...mapActions(useSavedPostsStore, ["watchSavedStatus", "tapSave"]),
    closeMountedChooser() {
      if (this.unmountChooser) {
        this.unmountChooser();
        this.unmountChooser = null;
      }
    },
    handleClick() {
      if (this.editMode || this.isPreviewMode || !this.canSavePosts || this.pendingByStory[Number(this.storyEntityId)]) {
        return;
      }
      this.chooserOwner = !this.isEngagementActive;
      this.tapSave(this.storyEntityId);
    },
  },
};
</script>
